import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody} from 'reactstrap';
import UploadFile from '../includes/UploadFile';
import * as galleryActions from "../../actions/gallery";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as uploadReducers from "../../reducers/upload";

class NewItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            vname_class : '',
            vtags_class : '',
            title: '',
            tags: '',
            modal: false,
            redirect: false,
            builderState : false,
            builderUrl : '',
            image_path: null,
            file_name : '',
            userDet : JSON.parse(window.localStorage.userDet),
            itemName : '',
            imageError : ""

        };

        this.toggle = this.toggle.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showBuilder = this.showBuilder.bind(this);
        this.hideBuilder = this.hideBuilder.bind(this)
        this.getFileType = this.getFileType.bind(this);

    }

    renderTitle() {
        let titleText = "Add ";
        switch(this.props.item_type) {
            case 'VIGNETS':
                return titleText += 'Vignets';
            case 'MY_UPLOADS':
                return titleText += 'Gallery';
            case 'AUDIO':
                return titleText += 'Audio';
            case 'VIDEO':
                return titleText += 'Video';
            case 'PLAYLIST':
                return titleText += 'Playlist';
            default:
                return titleText += 'Vignets';
        }
    }

    getItemName() {
        switch(this.props.item_type) {
            case 'VIGNETS':
                return 'Image';
            case 'MY_UPLOADS':
                return 'Image';
            case 'AUDIO':
                return 'Audio';
            case 'VIDEO':
                return 'Video';
            default:
                return 'Vignet';
        }
    }

    getFileType() {
        switch(this.props.item_type) {
            case 'VIGNETS':
                return 'image';
            case 'MY_UPLOADS':
                return 'image';
            case 'AUDIO':
                return 'audio';
            case 'VIDEO':
                return 'video';
            default:
                return 'Vignet';
        }
    }

    toggle() {
        this.setState({
            modal: !this.state.modal,
            image_path : null,
            title: '',
            tags: ''
        });
    }

    getUploadedFile(fileName) {
        var image_path = '';

        if (this.props.item_type === 'AUDIO') {
            image_path= 'assets/images/no-audio.jpg';
        }
        else if (this.props.item_type === 'VIDEO') {
            image_path= 'assets/images/no-video.jpg';
        }
        else  if( this.props.item_type === 'MY_UPLOADS') {
            image_path =  fileName;

        }

        this.setState({
            image_path: image_path,
            file_name : fileName
        });

    }

    showBuilder(e) {
        e.preventDefault();
        this.setState({
            builderState : true
        });
        this.handleSubmit(e, this.state.builderState);
    }

    hideBuilder(e) {
        e.preventDefault();
        this.setState({
            builderState : false
        });
        this.handleSubmit(e, this.state.builderState);
    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });

        if(event.target.value !== '') {
            event.target.classList.remove('is-invalid');
        }
    }

    handleSubmit(e) {
        //alert("111");
        e.preventDefault();
        let formInvalid = 0;

        if( this.state.title === '') {
            formInvalid++;
            document.getElementsByName('title')[0].classList.add('is-invalid');
        }

        if( this.state.file_name === '') {
            formInvalid++;
            this.setState({imageError : "Please upload a file"});
            document.getElementsByClassName('modal-adduser-img')[0].classList.add('is-invalid');
        }

        if( formInvalid === 0) {
            //alert("sdsfsf");

            var galData = { userid : this.state.userDet.user_id ,title :this.state.title, imgpth : this.state.file_name, tags: this.state.tags, imgtyp : this.props.item_type};

            let created = this.props.createGallery(galData);
            this.toggle();

        }
    }

    render() {

        return (
            <div className="ind-galler-list no-hov" data-toggle="modal" data-target="#newModal" onClick={this.toggle}>
                <div className="gallery-thumb">
                    <div className="new-button-block">
                        <button className="icon-lib add-button"></button>
                        <p>{this.renderTitle()}</p>
                    </div>
                </div>


                <Modal isOpen={this.state.modal} toggle={this.toggle} centered={true} className="vig-mod modal-lg vig-modal user-md create-new-pop">
                    <ModalBody>
                        <div className="modal-content-wrapper">
                            <div className="modal-header">
                                <form id="company">
                                    <button type="button" className="modal-btn-close" data-dismiss="modal" aria-label="Close" onClick={this.toggle} >✕</button>
                                    <h4 className="modal-title icon-lib title-icon">Add New</h4>
                                </form>
                            </div>
                            <div className="modal-adduser-content">
                                <div className="modal-adduser-content-left">
                                    <div className="modal-adduser-detail">
                                        <p>TITLE</p>
                                        <div className="input-select">
                                            <input type="text" name="title" id="title" placeholder="Title" className="input-box without-ico" onChange={this.handleInputChange} valid={false} />
                                        </div>
                                    </div>
                                    <div className="modal-adduser-detail">
                                        <p>TAGS</p>
                                        <div className="input-select desc-area">
                                            <textarea type="textarea" name="tags" id="tags" className="form-text" placeholder="Tags" onChange={this.handleInputChange} valid={false}/>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-adduser-content-right">
                                    <div className="modal-adduser-detail">
                                        <div className="modal-adduser-img">
                                            <div className="image-up">

                                                {this.state.image_path &&
                                                <img src={this.state.image_path} crossOrigin="anonymous" className="text-center" alt="vignet"/>
                                                }
                                                {this.state.image_path ===null && this.props.item_type === 'MY_UPLOADS' &&
                                                <img src="assets/images/placeholder.png" alt="default" />
                                                }
                                                {this.state.image_path ===null && this.props.item_type === 'AUDIO' &&
                                                <img src="assets/images/no-audio.jpg" alt="default" />
                                                }
                                                {this.state.image_path ===null && this.props.item_type === 'VIDEO' &&
                                                <img src="assets/images/no-video.jpg" alt="default" />
                                                }

                                                <UploadFile getUploadedFile={ this.getUploadedFile.bind(this)} type="add" item_type={this.props.item_type} fileType={this.getFileType()} unique_id="" />
                                                {(this.state.image_path ===null || this.props.uploadData.loader === true) &&
                                                <div id="progress-bar-wrapper"></div>
                                                }




                                                {/*<img src="assets/images/placeholder.png" alt="default" />
                                            <div className="upload-select">
                                                <button className="icon-lib edit-button">
                                                    <input type="file" className="hidden-input" />
                                                </button>
                                            </div>*/}

                                            </div>
                                        </div>

                                        {this.props.uploadData.errors === true &&
                                        <p className="error-message">{this.props.uploadData.errorMessage}</p>
                                        }
                                    </div>
                                </div>
                                <div className="modal-adduser-content-btn">
                                    <div className="modal-btn btn-cancel">
                                        <a href="javascript:void(0);" className="" onClick={this.toggle}>CANCEL</a>
                                    </div>
                                    <div  className="modal-btn btn-create">
                                        <a href="javascript:void(0);" className="" onClick = {(e) => this.handleSubmit(e)}>SAVE</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    {/*<ModalFooter>
                        <FormGroup className="pull-right button-gp">
                            <Button name="submit_form" type="button" color="info" className="gen-button" onClick = {(e) => this.handleSubmit(e)} >Save</Button>
                        </FormGroup>
                    </ModalFooter>*/}
                </Modal>

                {/*<Modal isOpen={this.state.modal} toggle={this.toggle} centered={true} className="vig-mod">
                <ModalHeader className="vignet-header" toggle={this.toggle}>Add New</ModalHeader>
                <ModalBody>
                    <div className="form_container">


                        <Form method="POST" >
                            <FormGroup>
                                <Label for="exampleEmail">Enter Title</Label>
                                <Input type="text" name="title" id="title" placeholder="Title" className={this.state.vname_class} onChange={this.handleInputChange} valid={false} />
                                <FormFeedback className={this.state.vname_class}  tooltip> Please enter a title</FormFeedback>
                            </FormGroup>

                            <FormGroup className="im_fr_grp">

                                <Label for="exampleEmail">Upload {this.getItemName()}</Label>

                                <div className="image-upload-block">
                                    <div className="image-up">
                                        {this.state.image_path &&
                                        <img src={this.state.image_path} crossOrigin="anonymous" className="text-center" alt="Demo"/>
                                        }
                                        {this.state.image_path ===null &&
                                        <img src="assets/images/placeholder.png" alt="default" />
                                        }

                                        <UploadFile getUploadedFile={this.getUploadedFile.bind(this)} type="add"/>
                                        {this.state.image_path ===null &&
                                        <div id="progress-bar-wrapper"></div>
                                        }
                                    </div>
                                </div>

                                <FormFeedback className={this.state.vname_class}  tooltip> Please enter a vignet name</FormFeedback>
                            </FormGroup>

                            <FormGroup>
                                <Label for="exampleText">Enter Tags</Label>
                                <Input type="textarea" name="tags" id="tags" onChange={this.handleInputChange} valid={false}/>
                                <FormFeedback className={this.state.vtags_class}  tooltip> Please enter tags</FormFeedback>
                            </FormGroup>

                        </Form>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <FormGroup className="pull-right button-gp">
                        <Button name="submit_form" type="button" color="info" className="save_btn" onClick = {(e) => this.handleSubmit(e)}  >Save</Button>
                    </FormGroup>
                </ModalFooter>
            </Modal>*/}
            </div>
        );
    }
}

NewItem.propTypes = {
    completed: PropTypes.number,
    item_type : PropTypes.string

}
function mapStateToProps(state) {
    return {
        uploadData : uploadReducers.getUploadData(state)
    };
}
export default  withRouter(connect(mapStateToProps, {
    createGallery : galleryActions.createGallery
})(NewItem));



// WEBPACK FOOTER //
// ./src/components/common/NewItem.js